import { render, staticRenderFns } from "./commit_widget.vue?vue&type=template&id=2ff3aaf3"
import script from "./commit_widget.vue?vue&type=script&lang=js"
export * from "./commit_widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports